import React, {FC, useState, ChangeEvent} from 'react';
import PlusIcon from "./Icons/PlusIcon";
import CameraIcon from "./Icons/CameraIcon";
import CrossIcon from "./Icons/CrossIcon";
import {useTranslation} from "react-i18next";
import {IFile, IGpsrQuestion} from "../types/gpsr-questions";

type QuestionCardProps = {
    topic: IGpsrQuestion;
    textareaChange: (value: string, topicID: string, questionID: string, pointID: string) => void;
    fileInputChange: (event: ChangeEvent<HTMLInputElement>, topicID: string, questionID: string, pointID: string) => void;
    confirmDeleteFileHandle: (topicID: string, questionID: string, pointID: string, file: IFile) => void;
}

const QuestionCard: FC<QuestionCardProps> = ({topic, textareaChange, fileInputChange, confirmDeleteFileHandle}) => {
    const { t } = useTranslation();

    const [currentTopicId, setCurrentTopicId] = useState<string>('')
    const [currentQuestionId, setCurrentQuestionId] = useState<string>('')
    const [currentPointId, setCurrentPointId] = useState<string>('')

    const openFileInputRef = (topicID: string, questionID: string, pointID: string) => {
        setCurrentTopicId(topicID)
        setCurrentQuestionId(questionID)
        setCurrentPointId(pointID)

        const input = document.querySelector(
            `input[data-point-id="${pointID}"]`
        ) as HTMLInputElement;

        if (input) {
            input.click();
        }
    }

    return (
        <div className='question-card'>
            <div className='question-card__topic'>{topic.topic}</div>

            {topic.questions.map((question, questionIndex) => (
                <div key={questionIndex}>
                    <div className={`question-card__question ${questionIndex > 0 ? 'mt-40' : ''}`}>{question.title}</div>

                    {question.points.map((point, pointIndex) => (
                        <div key={pointIndex}>
                            <div className={`question-card__point ${pointIndex > 0 ? 'mt-30' : ''}`}>{point.point}</div>

                            <div className='question-card-textarea-wrapper'>
                                <label>{t('gpsr:question_card_textarea_label_title')}</label>
                                <textarea
                                    rows={4}
                                    value={point.input}
                                    onChange={(e) =>
                                      textareaChange(e.target.value, topic.topicID, question.questionID, point.pointID)
                                    }
                                />
                            </div>

                            <div className='question-card__buttons-wrapper'>
                                <input type="file"
                                       multiple
                                       accept="image/*, application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                                       data-point-id={point.pointID}
                                       className='d-none'
                                       onChange={(e) => fileInputChange(e, currentTopicId, currentQuestionId, currentPointId)}
                                />
                                <button className='add-file-btn'
                                        onClick={() => openFileInputRef(topic.topicID, question.questionID, point.pointID)}
                                >
                                    {t('gpsr:add_file')} <PlusIcon />
                                </button>
                                <button className='camera-btn'
                                        onClick={() => openFileInputRef(topic.topicID, question.questionID, point.pointID)}
                                >
                                    <CameraIcon />
                                </button>
                            </div>

                            {point.files.length > 0 && point.files.map((file, index) => (
                                <div key={index}>
                                    <div className='question-card__files_wrapper'>
                                        <div className='question-card__file'>
                                            <button className='question-card__file_delete_btn'
                                                    onClick={() => confirmDeleteFileHandle(topic.topicID, question.questionID, point.pointID, file)}
                                            >
                                                <CrossIcon />
                                            </button>
                                            <span>
                                                {file.originalName}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            ))}

                            {point.example !== null &&
                                <div className='question-card__example'>
                                    <span>{point.example.text}</span>
                                    <a href={point.example.linkUrl} target='_blank'>{point.example.linkText}</a>
                                </div>
                            }
                        </div>
                    ))}
                </div>
            ))}
        </div>
    );
};

export default QuestionCard;